import React from 'react';
import { Box } from '@heycater/design-system';
import styled from 'styled-components';

import PriceField from 'qualification/components/question_types/PriceField';
import PriceStepper from 'qualification/components/question_types/PriceStepper';
import QuantityStepper from 'qualification/components/question_types/QuantityStepper';
import { useQualification } from 'qualification/context';
import { questions } from 'qualification/schema/questions';
import { pricePerPersonQuestion } from 'qualification/schema/questions/budgetQuestion';
import { steps } from 'qualification/schema/steps';

function BudgetFields() {
  const { errorsOf } = useQualification();

  const pricePerPersonErrors = errorsOf(pricePerPersonQuestion.id);

  return (
    <>
      <Box>
        {steps.budgetAndPeopleCount.questions.map((question) => {
          if (question.id === questions.peopleCount.id) {
            return <QuantityStepper key={''} />;
          }
          if (question.id === questions.pricePerPerson.id) {
            return <PriceStepper key={question.id} question={question} />;
          }
          if (question.id === questions.totalBudget.id) {
            return <PriceField key={question.id} />;
          }
        })}
      </Box>
      <ErrorWrapper>{pricePerPersonErrors[0]}</ErrorWrapper>
    </>
  );
}

const ErrorWrapper = styled.div`
  color: #e86202;
  font-weight: 500;
  max-width: 500px;
  margin: 0 auto;
`;

export default BudgetFields;
